import React from "react"

import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import { formatAmount, sanitizeIntegerInput } from "helpers/common"

function PaymentUtrModel({ icd, open, setOpen, validation, isLoading }) {
  const toggle = () => setOpen(!open)

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered size="md">
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Pay Offline
        </ModalHeader>
        <ModalBody>
          <Container>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row className="mb-2">
                <Col xl={12} className="mb-2">
                  <h5 className="form-label">Bank Account</h5>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xl={6} xs={12}>
                  <Label className="form-label">Name</Label>
                  <p>Prachay Capital Limited</p>
                </Col>
                <Col xl={6} xs={12}>
                  <Label className="form-label">Account No</Label>
                  <p>2306234047941198</p>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xl={6} xs={12}>
                  <Label className="form-label">IFSC Code</Label>
                  <p>AUBL0002340</p>
                </Col>
                <Col xl={6} xs={12}>
                  <Label className="form-label">Account Type</Label>
                  <p>Overdraft facility</p>
                </Col>
              </Row>
              <Row>
                <Col xl={12} xs={12}>
                  <Label className="form-label">Bank & Branch</Label>
                  <p>AU Small Finance Bank, Mumbai Andheri Kurla Road</p>
                </Col>
              </Row>
              <hr />
              <Row className="mb-2">
                <Col xl={12} className="mb-2">
                  <Label className="form-label" htmlFor="amount">
                    Already Paid Amount
                  </Label>
                  <h5>
                    ₹{" "}
                    {formatAmount(
                      icd?.investorsPayments?.reduce(
                        (sum, item) => sum + (item.amount || 0),
                        0
                      ) || 0
                    )}
                  </h5>
                </Col>
                <Col xl={6} className="mb-2">
                  <Label className="form-label" htmlFor="amount">
                    Amount
                  </Label>
                  <Input
                    name="amount"
                    id="amount"
                    className="form-control"
                    placeholder={"Enter amount"}
                    type="text"
                    value={`₹ ${formatAmount(validation.values.amount)}`}
                    onChange={(e) =>
                      sanitizeIntegerInput(
                        e,
                        validation.setFieldValue,
                        "amount"
                      )
                    }
                    invalid={
                      validation.touched.amount && validation.errors.amount
                    }
                  />
                  {validation.touched.amount && validation.errors.amount ? (
                    <FormFeedback type="invalid">
                      {validation.errors.amount}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={6} className="mb-2">
                  <Label className="form-label" htmlFor="itr">
                    UTR number
                  </Label>
                  <Input
                    name="itr"
                    id="itr"
                    className="form-control"
                    placeholder={"Enter UTR number."}
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.itr}
                    invalid={validation.touched.itr && validation.errors.itr}
                  />
                  {validation.touched.itr && validation.errors.itr ? (
                    <FormFeedback type="invalid">
                      {validation.errors.itr}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>

              <div className="mt-3 py-1 button-wrapper">
                <Button
                  type="submit"
                  color="primary"
                  className="w-100"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinners /> : "Submit"}
                </Button>
              </div>
            </Form>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default PaymentUtrModel
